export default __webpack_public_path__ + "static/media/user.bbc6ce5c.svg";